import type { Sensor3P, Gateway3P } from './useGetState';
import type { DtHeartbeatMaps } from './useGetDtHeartbeats';

export type Dt3pDeviceStatus = 'placeholder' | 'warning' | 'connected' | 'error';

/** Shared hex colors for DT device status — used by SVG feFlood filters across canvas item components. */
export const DT3P_STATUS_COLORS: Record<Dt3pDeviceStatus, string> = {
  placeholder: '#8F91A3',
  warning: '#EB860A',
  connected: '#10B981',
  error: '#FF0000',
};

export function computeSensor3pStatus(
  s: Sensor3P,
  maps: DtHeartbeatMaps | undefined,
): Dt3pDeviceStatus {
  if (!s.external_device_id) return 'placeholder';
  if (!s.provisioned_at) return 'warning';
  if (!maps) return 'placeholder'; // heartbeat data not yet loaded — don't show false red
  return maps.sensorMap[s.external_device_id] ? 'connected' : 'error';
}

export function computeGateway3pStatus(
  g: Gateway3P,
  maps: DtHeartbeatMaps | undefined,
): Dt3pDeviceStatus {
  if (!g.external_gateway_id) return 'placeholder';
  if (!g.provisioned_at) return 'warning';
  if (!maps) return 'placeholder'; // heartbeat data not yet loaded — don't show false red
  return maps.gatewayMap[g.external_gateway_id] ? 'connected' : 'error';
}
